<div>
    <h4 class="ap-green">Location Snapshot</h4>
</div>

<dx-accordion #accordion [collapsible]="true" [multiple]="false" [animationDuration]="450" id="accordion-container">
    <dxi-item class="mt-0 pt-0">
        <div *dxTemplate>
            <div *dxTemplate="let data of 'item'">
                <div class="">
                    <form validationGroup="facilityData" #facilityForm="ngForm" (ngSubmit)="loadReports()"
                        class="form-horizontal" autocomplete="off" showValidationSummary="true">
                        <div class="row mt-2 px-2">
                            <div class="col-md-3">
                                <div class="form-group text-center mt-4">
                                    <label class="ml-2 mr-2" for="country">Country<span style="color: red">
                                            *</span></label>
                                    <dx-tag-box name="country" id="country" [items]="userCountries" [multiline]="false"
                                        [searchEnabled]="true" [showSelectionControls]="true" displayExpr="countryName"
                                        valueExpr="countryID" (onSelectionChanged)="onCountrySelectionChanged()"
                                        [(value)]="locationSnapshot.filters.countryIDs">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Country is required">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-tag-box>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group text-center mt-4">
                                    <label class="ml-2 mr-2" for="apPlants">AP Plants<span style="color: red">
                                            *</span></label>
                                    <dx-tag-box id="apPlants" [disabled]="!isCountrySelected" name="apPlants"
                                        id="apPlants" [multiline]="false" [searchEnabled]="true"
                                        [showSelectionControls]="true" displayExpr="siteCombined" valueExpr="siteID"
                                        [items]="apPlants" [(value)]="locationSnapshot.filters.siteIDs">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="AP Plants is required">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-tag-box>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group text-center mt-4">
                                    <label class="ml-2 mr-2" for="globalIndustrySegment">Global Industry
                                        Segments<span style="color: red"> *</span></label>
                                    <dx-tag-box name="globalIndustrySegment" id="globalIndustrySegment"
                                        [items]="globalIndustrySegments" [multiline]="false" [searchEnabled]="true"
                                        [showSelectionControls]="true" displayExpr="name"
                                        valueExpr="globalIndustrySegmentId"
                                        [(value)]="locationSnapshot.filters.globalIndustrySegmentIDs">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Global Industry Segments is required">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-tag-box>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group text-center mt-4">
                                    <label class="ml-2 mr-2" for="radiusAroundEachPlant">Radius around each plant
                                        (miles)<span style="color: red"> *</span></label>
                                    <dx-number-box name="radiusAroundEachPlant" id="radiusAroundEachPlant"
                                        [(value)]="locationSnapshot.filters.radiusAroundEachPlant">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Radius is required">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-number-box>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 px-2">
                            <div class="col-md-2">
                                <dx-check-box id="includeSuspectList"
                                    [(value)]="locationSnapshot.filters.includeSuspectList"
                                    text="Include Suspect List"></dx-check-box>
                            </div>
                            <div class="col-md-2">
                                <dx-check-box id="removeExcluded" [(value)]="locationSnapshot.filters.removeExcluded"
                                    text="Remove Excluded"></dx-check-box>
                            </div>
                            <div class="col-md-2">
                                <dx-check-box id="crossCountryBorders"
                                    [(value)]="locationSnapshot.filters.crossCountryBorders"
                                    text="Cross Country Borders"></dx-check-box>
                            </div>
                            <div class="col-md-2">
                                <dx-check-box id="limitToSiteRevenueGrtThan1MM"
                                    [(value)]="locationSnapshot.filters.limitToSiteRevenueGrtThan1MM"
                                    text="Limit to SiteRevenue >$1MM"></dx-check-box>
                            </div>
                            <div class="col-md-2">
                                <dx-check-box id="showDistanceRings"
                                    [(value)]="locationSnapshot.filters.showDistanceRings"
                                    text="Show Distance Rings"></dx-check-box>
                            </div>
                            <div class="col-md-2">
                                <dx-check-box id="includeSAPCustomerList"
                                    [(value)]="locationSnapshot.filters.includeSAPCustomerList"
                                    text="Include SAP Customer List"></dx-check-box>
                            </div>
                        </div>
                        <br />
                        <div>
                            <div class="row px-2">
                                <div class="col-md-6">
                                    <div>SAP Volume Better Served</div>
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div> Trailer Size (MT)</div>
                                                    <dx-number-box [(value)]="locationSnapshot.filters.trailerSize">
                                                        <dx-validator>
                                                            <dxi-validation-rule type="required"
                                                                message="Please enter Trailer Size.">
                                                            </dxi-validation-rule>
                                                        </dx-validator>
                                                    </dx-number-box>
                                                </div>
                                                <div class="col-md-6">
                                                    <div> Distribution Cost ($/mi)</div>
                                                    <dx-number-box
                                                        [(value)]="locationSnapshot.filters.distributionCost">
                                                        <dx-validator>
                                                            <dxi-validation-rule type="required"
                                                                message="Please enter Distribution Cost.">
                                                            </dxi-validation-rule>
                                                        </dx-validator>
                                                    </dx-number-box>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label class="ml-2 mr-2" for="productbox">Product<span style="color: red">
                                            *</span></label>
                                    <dx-tag-box name="productbox" [items]="products" [multiline]="true"
                                        [searchEnabled]="true" (onOpened)="OnProductsCreated($event)" [showSelectionControls]="true" displayExpr="text"
                                        valueExpr="text" [(value)]="locationSnapshot.filters.product">
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Product is required">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-tag-box>
                                </div>
                            </div>
                        </div>

                        <div row="row">
                            <div class="col-md-12 mt-3 pr-0 text-right">
                                <dx-button [useSubmitBehavior]="true" text="Generate Reports"
                                    class="ap-green-btn ap-icon mr-1 mt-1 ml-2 px-3">
                                </dx-button>
                            </div>
                        </div>
                    </form>
                    <hr class="rounded">
                    <app-batch-reports-grid *ngIf="!removeBatchGrid" [reportType]="'Location Snapshot'"
                        (batchGridEvent)="onBatchGridEvent($event)"></app-batch-reports-grid>
                </div>
            </div>
        </div>
    </dxi-item>
</dx-accordion>


<div [hidden]="!isDataLoaded">
    <div row="row">
        <div class="col-md-12 mt-3 pr-0 text-right">
            <dx-button [(visible)]="exportButtonVisible" text="Export Reports" icon="xlsxfile"
                class="ap-green-btn ap-icon mr-2 mt-1 px-3" (onClick)="exportGrids($event)"></dx-button>
        </div>
    </div>
    <dx-tab-panel #LSTabPanel [deferRendering]="false">
        <dxi-item title="Demand Capacity">
            <div *dxTemplate>
                <demand-capacity #demandCapacity [hidden]="!isDataLoaded"
                    [demandCapacities]="locationSnapshot.demandCapacities"
                    [capacityByPlants]="locationSnapshot.capacityByPlants"
                    [exclusiveCapacityByPlants]="locationSnapshot.exclusiveCapacityByPlants"
                    [filters]="locationSnapshot.filters">
                </demand-capacity>
            </div>
        </dxi-item>
        <dxi-item title="Opportunities">
            <opportunities #opportunities [hidden]="!isDataLoaded" [opportunities]="locationSnapshot.opportunities"
                [miles]="locationSnapshot.filters.radiusAroundEachPlant"></opportunities>
        </dxi-item>
        <dxi-item title="Open Leads by Plant">
            <div *dxTemplate>
                <open-leads-by-plant #openLeads [hidden]="!isDataLoaded" [openLeads]="locationSnapshot.openLeadsByPlant"
                    [miles]="locationSnapshot.filters.radiusAroundEachPlant"></open-leads-by-plant>
            </div>
        </dxi-item>
        <dxi-item title="Suspect Map">
            <suspect-map #suspectMap [hidden]="!isDataLoaded" [suspectMap]="locationSnapshot.suspectMap"
                [filters]="locationSnapshot.filters" (export)="exportSuspectMapOnly()"></suspect-map>
        </dxi-item>
        <dxi-item title="Suspect Heat Map">
            <suspect-heat-map #suspectHeatMap [hidden]="!isDataLoaded" [suspectMap]="locationSnapshot.suspectMap"
                [filters]="locationSnapshot.filters" (export)="exportSuspectHeatMapOnly()"></suspect-heat-map>
        </dxi-item>
        <dxi-item title="Suspects Alt Heat Map">
            <suspects-alt-heat-map #suspectAltHeatMap [suspectAltHeatMap]="locationSnapshot.suspectAltHeatMap"
                [filters]="locationSnapshot.filters" (export)="exportAltSuspectHeatMapOnly()"></suspects-alt-heat-map>
        </dxi-item>
        <dxi-item title="Demand by Distance">
            <demand-by-distance #demandByDistance [hidden]="!isDataLoaded"
                [demandByDistances]="locationSnapshot.demandByDistances" [filters]="locationSnapshot.filters"></demand-by-distance>
        </dxi-item>
        <dxi-item title="SAP Volume Better Served">
            <sap-volume-better-served #sapVolumeBetterServed [hidden]="!isDataLoaded"
                [sapVolumeBetterServed]="locationSnapshot.sapVolumeBetterServed"></sap-volume-better-served>
        </dxi-item>
        <dxi-item title="Suspect List" [visible]="locationSnapshot.filters.includeSuspectList">
            <suspect-list #suspectList [hidden]="!isDataLoaded" [suspectList]="locationSnapshot.suspectList"
                [miles]="locationSnapshot.filters.radiusAroundEachPlant"
                [siteNames]="locationSnapshot.filters.siteNames"></suspect-list>
        </dxi-item>
        <dxi-item title="Suspects with Contact Names">
            <suspects-with-contact-names #suspectsWithContactNames [hidden]="!isDataLoaded"
                [suspectsWithContactNames]="locationSnapshot.suspectsWithContactNames"></suspects-with-contact-names>
        </dxi-item>
    </dx-tab-panel>
</div>


<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="isLoadPanelVisible" [showPane]="true"
    [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>